import { useRoutes, Navigate, Link } from 'react-router-dom';
import Loadable from '../ui-component/Loadable';
import MinimalLayout from '../layout/MinimalLayout';

import { lazy } from 'react';
const Accueil = Loadable(lazy(() => import('../pages/accueil')));
const About = Loadable(lazy(() => import('../pages/about')));
const Contact = Loadable(lazy(() => import('../pages/contact')));
const Politics = Loadable(lazy(() => import('../pages/politics')));
const CGV = Loadable(lazy(() => import('../pages/cgv')));
const CGU = Loadable(lazy(() => import('../pages/cgu')));
const MentionsLegales = Loadable(lazy(() => import('../pages/mentions-legales')));
const Services = Loadable(lazy(() => import('../pages/services')));
export default function ThemeRoutes() {
    return useRoutes([
        {
            path: '/',
            element: <MinimalLayout />,
            children: [
                // Add your routes here
                {
                    path: '',
                    element: <Accueil />,
                },
                {
                    path: 'a-propos',
                    element: <About />,
                },
                {
                    path: 'mentions-legales',
                    element: <MentionsLegales />,
                },
                {
                    path: 'contact',
                    element: <Contact />,
                },
                {
                    path: 'politics',
                    element: <Politics />,
                },
                {
                    path: 'cgu',
                    element: <CGU />,
                },
                {
                    path: 'cgv',
                    element: <CGV />,
                },
                {
                    path: 'services',
                    element: <Services />,
                }
            ],
        },
    ])
}